import { render, staticRenderFns } from "./ListDamages.vue?vue&type=template&id=4f07320b&"
import script from "./ListDamages.vue?vue&type=script&lang=js&"
export * from "./ListDamages.vue?vue&type=script&lang=js&"
import style0 from "./ListDamages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports